import { AxiosError } from 'axios';

import { msalInstance, protectedResources } from 'common/config/auth.config';
import { HttpHeaderKey } from 'common/enums/api-status.enum';
import { ApiResult } from 'common/models/api-service/api-result.model';

import { BaseHTTPClient } from './base-http-client.service';

export class GraphClient extends BaseHTTPClient {
    static async getCurrentUserProfile(): Promise<ApiResult<any>> {
        try {
            const acquireTokenResult = await msalInstance.acquireTokenSilent({
                scopes: protectedResources.api.scopes
            });
            const header = {
                [HttpHeaderKey.Authorization]: `Bearer ${acquireTokenResult.accessToken}`
            };

            const url = `${protectedResources.graph.endpoint}/me`;
            return await this.get<any>(url, header);
        } catch (e) {
            const axiosError: AxiosError = e as AxiosError;
            return new ApiResult<any>(
                axiosError.response?.data as any,
                axiosError.response?.status,
                axiosError.message
            );
        }
    }

    static async getCurrentUserAvatar(): Promise<ApiResult<Blob>> {
        try {
            const acquireTokenResult = await msalInstance.acquireTokenSilent({
                scopes: protectedResources.api.scopes
            });
            const header = {
                [HttpHeaderKey.Authorization]: `Bearer ${acquireTokenResult.accessToken}`
            };

            const url = `${protectedResources.graph.endpoint}/me/photos/48x48/$value`;
            return await this.get<Blob>(url, header, 'blob');
        } catch (e) {
            const axiosError: AxiosError = e as AxiosError;
            return new ApiResult(
                axiosError.response?.data,
                axiosError.response?.status,
                axiosError.message
            ) as unknown as any;
        }
    }
}
